import { ButtonProps } from '@mui/joy';
import { t } from 'i18next';
import { useState } from 'react';

import { Button } from 'core/components';
import { QuoteHelper } from 'quotes/helpers';
import { ICustomerQuote } from 'quotes/types';
import { Variant } from 'theme/enums';

import { UpdateQuoteAddress } from './UpdateQuoteAddress';
import { ContactGroupAddressType } from './UpdateQuoteAddress';

interface IProps extends ButtonProps {
  quote?: ICustomerQuote;
  text?: string;
  onSubmitSuccess?: () => void;
}

export const EditShipToAddressButton = ({
  quote,
  text = t('buttonLabelEditShipToAddress'),
  onSubmitSuccess,
  ...rest
}: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  return (
    <>
      <Button text={text} variant={Variant.SOFT} onClick={() => setIsEditOpen(true)} {...rest} />

      <UpdateQuoteAddress
        isOpen={isEditOpen}
        quote={quote}
        entityType={QuoteHelper.determineEntityType(quote)}
        onClose={() => setIsEditOpen(false)}
        addressType={ContactGroupAddressType.SHIP_TO}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
